import {
  Button,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import React, { useState, useRef, useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  listItem: {
    border: "1px solid #C4C4C4",
    background: "#FFFFFF",
    marginRight: 10,
    borderRadius: 4,
    boxSizing: "border-box",
    height: 42,
    width: 150,
    top: -3,
  },
  listSecoundItem: {
    top: 17,
  },
  vl: {
    border: "1px solid #C4C4C4",
    height: 40,
    width: 0,
  },
  typography: {
    fontWeight: "500",
    fontSize: 16,
    color: "#4B4B4B",
  },
  button: {
    width: 150,
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
    marginBottom: 10,
  },
  list: {
    display: "flex",
    flexDirection: "row",
    padding: 0,
  },
  filename: {
    maxWidth: 190,
    wordWrap: "break-word",
  },
  filesDisplayList: {
    marginBottom: 10,
    borderBottom: "1px #D0D0D0	inset",
  },
}));

const getShortFileName = (fileName) => {
  var shortNameIndex = fileName.indexOf("_");
  var shortName = fileName.slice(shortNameIndex + 1);
  return shortName;
};

const getLastFileNumber = (filesNames) => {
  let fileNumbers = filesNames.map(
    (name) => parseInt(name.replace(/^\D+/g, "")) || 0
  );
  if (fileNumbers.length === 0) return 0;
  let lastFileNumber = Math.max(...fileNumbers);
  return lastFileNumber;
};

export default function FilesDisplayList(props) {
  const {
    filesCategory,
    multipleFiles,
    fileName,
    files,
    uploadFile,
    deleteFile,
    downloadFile,
    disabled,
  } = props;

  const classes = useStyles();
  const [fileNames, setFileNames] = useState([]);
  const [hasFile, setHasFile] = useState(files?.length > 0);
  const [fileNumber, setFileNumber] = useState(0);

  const fileUploadRef = useRef(null);

  const changeHandler = async (event) => {
    const file = event.target.files[0];
    let fileFixName = fileName;
    if (multipleFiles) {
      fileFixName = `${fileFixName}_${fileNumber + 1}`;
      setFileNumber(fileNumber + 1);
    }
    uploadFile({ file, fileName: fileFixName });
  };

  const handleSubmission = () => {
    fileUploadRef.current.click();
  };

  useEffect(() => {
    const fileNames = files?.map((f) => getShortFileName(f.name));
    if (fileNames !== undefined) {
      if (fileNames.length > 0) {
        setHasFile(true);
      }
      setFileNames(fileNames);
      if (multipleFiles) {
        setFileNumber(getLastFileNumber(fileNames));
      }
    }
  }, [files, fileName, multipleFiles]);

  const handleDeleteFile = (fileName) => {
    deleteFile({ fileName });
  };

  return (
    <Grid container spacing={2} className={classes.filesDisplayList}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom className={classes.typography}>
          {filesCategory}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <input
          ref={fileUploadRef}
          accept="application/pdf"
          onChange={changeHandler}
          type="file"
          style={{ display: "none" }}
          multiple={true}
        />
        <Button
          disableElevation
          variant="contained"
          color="primary"
          className={classes.button}
          startIcon={<CloudUploadIcon />}
          onClick={handleSubmission}
          disabled={disabled}
        >
          {hasFile ? "Upload New" : "Upload"}
        </Button>
      </Grid>
      <Grid item xs={8}>
        <List dense={false} className={classes.list}>
          {fileNames.map((name, index) => (
            <ListItem key={`${name}+${index}`} className={classes.listItem}>
              <ListItemText
                primary={
                  multipleFiles ? (
                    <Typography
                      className={classes.filename}
                    >{`file(${name.slice(name.indexOf("_") + 1)})`}</Typography>
                  ) : (
                    <Typography
                      className={classes.filename}
                    >{`file`}</Typography>
                  )
                }
              />
              <ListItemSecondaryAction className={classes.listSecoundItem}>
                <IconButton
                  edge="end"
                  onClick={() => downloadFile(name)}
                  size="large"
                >
                  <CloudDownloadIcon />
                </IconButton>
                <IconButton
                  edge="end"
                  onClick={() => handleDeleteFile(name)}
                  disabled={disabled}
                  size="large"
                >
                  <CloseIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Grid>
    </Grid>
  );
}
